import './Button.scss';
import { Button as MButton, ButtonProps } from '@mantine/core';
import React from 'react';
import { MLoader } from '@/components/MLoader/MLoader';

export interface IButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  customClass?: string;
}

export const Button: React.FC<IButtonProps & ButtonProps> = ({
  children,
  onClick,
  customClass = '',
  ...otherProps
}) => (
  <>
    {otherProps.loading ? (
      <div className={`custom-button-loader ${customClass}`}>
        <MLoader />
      </div>
    ) : (
      <MButton
        onClick={onClick}
        fz={{
          base: 18,
          xs: 'xl',
        }}
        fw="bold"
        styles={(theme) => ({
          root: {
            border: 0,
            height: 48,
            lineHeight: 1.5,
            borderRadius: otherProps.radius ?? theme.radius.md,
            ':active': { transform: 'none' },
            '&[data-disabled]': {
              backgroundColor: theme?.colors?.primary?.[2] ?? '#BCB0D7',
              color: theme?.colors?.white ?? '#FFFFFF',
            },
          },
        })}
        {...otherProps}
      >
        {children}
      </MButton>
    )}
  </>
);
